export default {
	scrollBehavior() {
		// Keep scroll untouched during navigation; transitions handle resetting
		return false
	},
	// scrollBehavior(to, from, savedPosition) {
	// 	if (import.meta.client) {
	// 		const top = Number(savedPosition?.top)
	// 		const left = Number(savedPosition?.left)
	// 		window.__silkriverPendingScrollRestore =
	// 			savedPosition && Number.isFinite(top)
	// 				? {
	// 						top,
	// 						left: Number.isFinite(left) ? left : 0,
	// 				  }
	// 				: null
	// 	}

	// 	if (savedPosition) return savedPosition
	// 	return { left: 0, top: 0 }
	// },
}
